export function doorStatusReducer(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'door') {
                return action.message.payload.doorStatus === 'DoorOpen';
            }
    }
    return state;
}
export function stopRequestReducer(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'door') {
                return action.message.payload.stopRequest;
            }
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/DoorStatus/reducers.ts
// module id = 1824
// module chunks = 0